import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DocumentService } from '../../services/coreService/document.service';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-bind-fields-ai',
  templateUrl: './bind-fields-ai.component.html',
  styleUrls: ['./bind-fields-ai.component.scss']
})
export class BindFieldsAIComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  LoggedInEmailId: string = "";
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  ExtractDocument:any=[]=[];
  Feildproperty:any=[] = []; 
  @Input() folderID: number = 0;
  
  @Output() closeBindEmit = new EventEmitter<boolean>();

  clickEventsubscriptionCoreAI: Subscription;
  
  feildsCtrl: FormControl;

  filteredFeilds: any=[]=[];
  ShowDeleteButton:boolean=false;

  CreateField:boolean=true;
  Finish:boolean=true;
  fieldListFiltered:any=[];
  selectedFileArray: any = [] = [];

  constructor(private _dataSharingService: DataSharingService,
    private loaderService: LoaderService,private encryptionAlgo: EncryptionService, 
    private reusableClass: ReusableClasses,private statusConst: StatusConstant,
    private documentService: DocumentService,private dialog: MatDialog,
    private toastr: ToastrService,) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.LoggedInEmailId = sessionStorage.getItem('email');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID)
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });

      this.feildsCtrl = new FormControl();
      this.filteredFeilds = this.feildsCtrl.valueChanges.pipe(startWith(''),
      map((feilds) =>
      feilds ? this.filterFeilds(feilds) : this.Feildproperty.slice()));
      }

    filterFeilds(name: string) {
    let arr = this.Feildproperty.filter((feilds) => feilds.fieldName.toLowerCase().indexOf(name.toLowerCase()) === 0);

    if(arr.length==0){
     this.CreateField=false;
     this.Finish=true;
    }
    return arr;//.length;// ? arr : [{ name: 'No Item found', code: 'null' }];
  }

  ngOnDestroy() {
    this.ExtractDocument=[];
    this.selectedFileArray=[];
    this.ShowDeleteButton=false;
    this.clickEventsubscriptionCoreAI.unsubscribe();
  }

  ngOnInit(): void {
    this.clickEventsubscriptionCoreAI = this._dataSharingService.getSelectedDocForBindAI().subscribe((result:any) => {
      if(result) {
       this.CreateField=true;
       this.Finish=true;
       this.fieldListFiltered=[];
       this.ExtractDocument=[];
       this.selectedFileArray=[];
       this.ShowDeleteButton=false;
       this.extractDocumentData(result);
      }
      this.getFieldForImportExport();
    });
  }

  extractDocumentData(document:any){
    let ReqModel = {
      cccid: Number(this.folderID),
      typeID: 1, //1-Core, 2-Contact, 3-Company
      docUrl: document.azureblobPath,
      placehlderID: document.placeholderID,
      documentID: 0,
      callFrom: 1,  //1-CCC / FileManager-2
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      databaseID: Number(this.databaseId),     
    };
    this.loaderService.show();
    this.documentService.extractDocumentData(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response.data.keyValueData;
        this.ExtractDocument= this.responseHolder;
        if (this.ExtractDocument.length > 0) {
          this.ExtractDocument.map(e => {
           // e.fieldID = 0;
            e.id = this.randomId();
            //e.fieldName = '';
          });
        }
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
    });
  }

   randomId() {
    return Math.random();
  }

  closeAiDetail(closeDetail: boolean) {
    this.feildsCtrl.reset();  
    this.fieldListFiltered=[];
    this.ExtractDocument=[];
    this.selectedFileArray=[];
    this.ShowDeleteButton=false;
    this.CreateField=true;
    this.Finish=true;
    this.closeBindEmit.emit(closeDetail);    
  }


   // GetFieldForApi for Dropdown // 
   getFieldForImportExport() {
      var ReqModel = {
        folderID: this.folderID,
        UserId: this.currentUser.UID,
        OrganizationID:  Number(this.organizationId),      
        officeID: this.myOfficeID,
       }
       this.documentService.GetFieldForImportExport(ReqModel).subscribe(response => {
       if(response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.Feildproperty = this.responseHolder.data;
          }else{
            this.Feildproperty =[];          
          }
        }else{
          this.Feildproperty =[];          
        }
      });
   } 




   //Checkbox Change detecting function
   getCheckboxValues(event, document) {   
    this.ShowDeleteButton = true;
    if (event.checked) {
      let ReqModel = {
        selectedDocument: document,
      };
      this.selectedFileArray.push(ReqModel);     
    } else {
      let removeIndex = this.selectedFileArray.findIndex((itm) => itm.selectedDocument === document);
      if (removeIndex !== -1) this.selectedFileArray.splice(removeIndex, 1);    
    }
    if(this.selectedFileArray.length == 0) {     
     this.ShowDeleteButton = false;      
    }
   }

   deleteSelectedFields() {
    const message = `Are you sure you want to delete this fields?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {         
          for (let i = 0; i < this.selectedFileArray.length; i++) {
            const index: number = this.ExtractDocument.indexOf(this.selectedFileArray[i].selectedDocument);
             if (index !== -1) {
              this.ExtractDocument.splice(index, 1);
             } 
          }
          this.selectedFileArray=[];
          this.ShowDeleteButton=false;
          this.toastr.success('Fields deleted successfully.', '', {
            timeOut: 3000,
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  searchFields(val,items:any) {
    if(val!==undefined && val!=="") {
     this.fieldListFiltered=this.Feildproperty.filter(m=>m.fieldName.toLowerCase().includes(val.toLowerCase()));
     const index = this.ExtractDocument.indexOf(items);
      if (index >= 0) {
       this.ExtractDocument.find((item) => item.id == items.id).fieldName = val;      
      }
    
     if(this.fieldListFiltered.length==0){
       this.CreateField=false;
       this.Finish=true;
     }

    //  var check=[];
    //  check = this.ExtractDocument.filter(x=>x.fieldID==0);
    //  if(check.length>0){
    //    this.CreateField=true;
    //    this.Finish=true;
    //  }
    }
    else{
      this.fieldListFiltered=[];
    }
  }

  fieldValueSelected(value:any,items:any){
    const index = this.ExtractDocument.indexOf(items);
    if (index >= 0) {
      if(value.fieldID>0){
        this.ExtractDocument.find((item) => item.id == items.id).fieldID = value.fieldID;
        this.ExtractDocument.find((item) => item.id == items.id).fieldName = null;
      }      
    }

    var check=[];
    check = this.ExtractDocument.filter(x=>x.fieldName!=null);
    if(check.length>0){
      this.CreateField=false;
      this.Finish=true;
    }else{
      this.CreateField=true;
      this.Finish=false;
    }
  }


  createFields(){
    var check=[];
    var newFields=[];
    check= this.ExtractDocument.filter(x=>x.fieldName!=null || x.fieldID!=0);
    if(check.length>0){
      for (let i = 0; i < check.length; i++){
        var fieldName;
        if(check[i].fieldID>0){
         var data=[];
         data= this.Feildproperty.filter(x=>x.fieldID==check[i].fieldID);
         if(data.length>0){
          fieldName=data[0].fieldName;
         }
        }else{
          fieldName=check[i].fieldName;
        }
        var obj={
          keyID: check[i].keyID,
          keyName: check[i].key,
          fieldName: fieldName, //check[i].fieldName,
          fieldID: check[i].fieldID,
        }
        newFields.push(obj);
      }
    }   
   
    var reqModel={
      newFields: newFields,
      organizationID: Number(this.organizationId), 
      officeID: this.myOfficeID,
      userID: this.currentUser.UID,
      folderID: this.folderID,
    }
    //return;
    this.loaderService.show();
    this.documentService.addFormKeyAsNewFields(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) { 
          //this.getFieldForImportExport();
          this.loaderService.hide();
          this.closeAiDetail(false);
          this.toastr.success('Field created successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
          this.toastr.error('Field creation failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
        this.toastr.error('Field creation failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  finishFields(){

  }

}
